<template>
  <!--坐标上传组件 -->
  <el-dialog
    title="交付设置"
    style="color:white;"
    :visible.sync="dialogFormVisible"
    append-to-body
    custom-class="deDialog"
  >
    <div class="abody">
      <el-form :model="item" ref="itemForm" :rules="itemRule" label-width="90px" class="itemForm">
        <el-form-item label="数据时效" prop="type">
          <el-select v-model="item.type" placeholder="请选择">
            <el-option
              v-for="option in types"
              :key="option.value"
              :label="option.label"
              :value="option.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="item.name" style="width:36%;"></el-input>
        </el-form-item>
        <el-form-item label="每单个数" prop="quantity" v-if="item.type === '历史数据'">
          <el-input v-model="item.quantity" placeholder="每单个数" style="width:36%;"></el-input>
        </el-form-item>
        <el-form-item label="定时设置" prop="period_type">
          <el-select v-model="item.period_type" placeholder="请选择">
            <el-option
              v-for="option in periods"
              :key="option.value"
              :label="option.label"
              :value="option.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="每隔" prop="period_value">
          <el-input v-model="item.period_value" style="width:36%;"></el-input>
          {{item.period_type}}发生一次
        </el-form-item>
        <el-form-item label="开始" prop="taskStartDate">
          <el-date-picker
            v-model="item.taskStartDate"
            type="date"
            :pickerOptions="taskStartDate"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="item.period_type === '月'">
          <el-select v-model="item.taskRunDay" placeholder="请选择">
            <el-option
              v-for="option in days"
              :key="option.value"
              :label="option.label"
              :value="option.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="item.period_type === '周'">
          <el-select v-model="item.taskRunWeekDay" placeholder="请选择">
            <el-option
              v-for="option in weekDays"
              :key="option.value"
              :label="option.label"
              :value="option.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="taskStartTime">
          <el-time-picker
            v-model="item.taskStartTime"
            placeholder="选择时间">
          </el-time-picker>
        </el-form-item>
        <el-form-item label="交付方式" prop="deliveryType">
          <el-select v-model="item.deliveryType" placeholder="请选择" @change="resetAddressId">
            <el-option
              v-for="option in deliveryTypes"
              :key="option.value"
              :label="option.label"
              :value="option.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="item.deliveryType !== '0' && item.deliveryType !== '' && addressList.length>0">
          <el-radio-group v-model="addressId">
                <el-radio v-for="(item,index) in addressList" :key="index"
                 :label="index" @change="handleRadio" style="display:block;margin : 5px 0 15px 0px;">
                    <span>{{ addressDetail(item) }}</span>
                </el-radio>
            </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-top: 20px;text-align: center;">
      <el-button
        class="buttongteys"
        @click="preStep"
      >上一步</el-button>
      <el-button
        :loading="loading"
        style="margin-left: 60px;"
        type="primary"
        class="buttongtey"
        @click="submit"
      >提交</el-button>

    </div>

  </el-dialog>
</template>

<script>
export default {
  name: 'HeadDeliverySetDialog',
  props: ['msgFather', 'prodata', 'dscatalogs', 'startDate', 'endDate', 'regionType', 'regionId', 'regionGeom', 'remoteSenseFormData', 'radio'],
  data () {
    return {
      dialogFormVisible: false,
      catalogCodes: [],
      loading: false,
      item: {
        type: '',
        quantity: '',
        name: '',
        period_type: '',
        period_value: '',
        taskStartDate: new Date(),
        taskStartTime: '',
        deliveryType: '',
        taskRunDay: '',
        taskRunWeekDay: ''
      },
      taskStartDate: {
        disabledDate(v) {
          return v.getTime() < new Date().getTime() - 86400000
        }
      },
      itemRule: {
        type: [
          { required: true, message: '请选择数据时效', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        quantity: [
          { required: true, message: '请输入每单个数', trigger: 'blur' },
          { pattern: /^\d+$/, message: '请输入数字' }
        ],
        period_type: [
          { required: true, message: '请选择定时设置', trigger: 'blur' }
        ],
        period_value: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        deliveryType: [
          { required: true, message: '请选择交付方式', trigger: 'blur' }
        ]
      },
      types: [
        {
          value: '历史数据',
          label: '历史数据'
        }, {
          value: '预定数据',
          label: '预定数据'
        }
      ],
      periods: [
        {
          value: '分',
          label: '分'
        }, {
          value: '时',
          label: '时'
        }, {
          value: '天',
          label: '天'
        }, {
          value: '周',
          label: '周'
        }, {
          value: '月',
          label: '月'
        }
      ],
      days: [
        {
          value: 1,
          label: '1号'
        }, {
          value: 2,
          label: '2号'
        }, {
          value: 3,
          label: '3号'
        }, {
          value: 4,
          label: '4号'
        }, {
          value: 5,
          label: '5号'
        }, {
          value: 6,
          label: '6号'
        }, {
          value: 7,
          label: '7号'
        }, {
          value: 8,
          label: '8号'
        }, {
          value: 9,
          label: '9号'
        }, {
          value: 10,
          label: '10号'
        }, {
          value: 11,
          label: '11号'
        }, {
          value: 12,
          label: '12号'
        }, {
          value: 13,
          label: '13号'
        }, {
          value: 14,
          label: '14号'
        }, {
          value: 15,
          label: '15号'
        }, {
          value: 16,
          label: '16号'
        }, {
          value: 17,
          label: '17号'
        }, {
          value: 18,
          label: '18号'
        }, {
          value: 19,
          label: '19号'
        }, {
          value: 20,
          label: '20号'
        }, {
          value: 21,
          label: '21号'
        }, {
          value: 22,
          label: '22号'
        }, {
          value: 23,
          label: '23号'
        }, {
          value: 24,
          label: '24号'
        }, {
          value: 25,
          label: '25号'
        }, {
          value: 26,
          label: '26号'
        }, {
          value: 27,
          label: '27号'
        }, {
          value: 28,
          label: '28号'
        }, {
          value: 29,
          label: '29号'
        }, {
          value: 30,
          label: '30号'
        }, {
          value: 31,
          label: '31号'
        }
      ],
      weekDays: [
        {
          value: 1,
          label: '周一'
        }, {
          value: 2,
          label: '周二'
        }, {
          value: 3,
          label: '周三'
        }, {
          value: 4,
          label: '周四'
        }, {
          value: 5,
          label: '周五'
        }, {
          value: 6,
          label: '周六'
        },
        {
          value: 7,
          label: '周日'
        }
      ],
      deliveryTypes: [
        {
          value: '0',
          label: '下载'
        }, {
          value: '1',
          label: '推送'
        }, {
          value: '3',
          label: '接收'
        }, {
          value: '2',
          label: '离线'
        }
      ],
      fileList: [],
      addressId: 0,
      addressList: [],
      geometry: '',
      user: {
        userId: '',
        userName: '',
        nickName: '',
        sex: '',
        rank: '',
        accountType: '',
        accessToken: ''
      }
    }
  },
  created () {

  },
  methods: {
    format: function(fmt, data) {
      var o = {
        'M+': data.getMonth() + 1,
        'd+': data.getDate(),
        'h+': data.getHours(),
        'm+': data.getMinutes(),
        's+': data.getSeconds(),
        'q+': Math.floor((data.getMonth() + 3) / 3),
        S: data.getMilliseconds()
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (data.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
          )
        }
      }
      return fmt
    },
    resetAddressId() {
      this.addressId = 0
      this.selectAddressId = 0
    },
    addressDetail(item) {
      if (this.item.deliveryType === '1') {
        return item.url
      }
      if (this.item.deliveryType === '2') {
        let addressDetail = item.address_detail + item.address
        addressDetail = (addressDetail.toString()).replace(/\s*/g, '')
        return addressDetail
      }
      if (this.item.deliveryType === '3') {
        return item.host_ip
      }
    },
    handleRadio(val) {
      this.addressId = val
    },
    sendMsgToParent: function () {
      this.$emit('getSetdialogFormVisible', this.dialogFormVisible)
    },
    preStep() {
      this.dialogFormVisible = false
      if (this.radio === '1') {
        this.$emit('getboundarydialogFormVisible', true)
      } else {
        this.$emit('getweftdialogFormVisible', true)
      }
    },
    submit() {
      this.user = JSON.parse(localStorage.getItem('user'))
      if (this.user === null) {
        this.$message.warning('请先登录！')
        return
      }
      this.$refs.itemForm.validate(valid => {
        // 校验交付设置表单
        if (valid) {
          // 校验是否选择产品类型
          if (this.dscatalogs.length === 0) {
            this.$message.warning('请选择数据信息！')
            return false
          }
          // 是否选择区域未选择设置中国区域
          if (this.regionId === '' && this.regionType === '') {
            this.regionType = 'custom'
            this.geometry = 'MULTIPOLYGON(((72 2,72 54,136 54,136 2,72 2)))'
          }
          // 组装接口参数
          if (this.regionType === 'custom') {
            this.regionId = ''
          } else {
            this.geometry = ''
          }

          let selectAddressId = ''
          if (this.item.deliveryType !== '0') {
            if (this.addressList.length === 0) {
              this.$message.warning('请添加交付地址！')
              return false
            } else {
              selectAddressId = this.addressList[this.addressId].id
              if (this.item.deliveryType === '3') {
                selectAddressId = this.addressList[this.addressId].upload_user_id.toString()
              }
            }
          }

          let subscriptionOrder = {
            'accessToken': this.user.accessToken,
            'name': this.item.name,
            'startDate': this.startDate,
            'endDate': this.endDate,
            'spatial_resolution_min': this.remoteSenseFormData['spatial_resolution_min'],
            'spatial_resolution_max': this.remoteSenseFormData['spatial_resolution_max'],
            'sun_elevation_min': this.remoteSenseFormData['sun_elevation_min'],
            'sun_elevation_max': this.remoteSenseFormData['sun_elevation_max'],
            'cloud_percent_min': this.remoteSenseFormData['cloud_percent_min'],
            'cloud_percent_max': this.remoteSenseFormData['cloud_percent_max'],
            'catalogCode': this.catalogCodes,
            'regionType': this.regionType,
            'regionId': this.regionId,
            'geometry': this.geometry,
            'dataTimeType': this.item.type,
            'quantity': this.item.quantity,
            'periodType': this.item.period_type,
            'periodValue': this.item.period_value,
            'taskStartDate': this.format('yyyy-MM-dd', this.item.taskStartDate),
            'taskRunDay': this.item.taskRunDay,
            'taskRunWeekDay': this.item.taskRunWeekDay,
            'taskStartTime': this.format('hh:mm:ss', this.item.taskStartTime),
            'deliveryType': this.item.deliveryType,
            'addressId': selectAddressId
          }
          console.log(subscriptionOrder)
          this.loading = true
          // 调用接口
          this.sapost('/dmc/subscriptionOrder/orderSubmit', subscriptionOrder, r => {
            let { returnMsg, returnCode } = r.data
            if (returnCode === '000') {
              this.$message.success(returnMsg)
              this.dialogFormVisible = false
              this.$refs.itemForm.resetFields()
            } else {
              this.$message.warning(returnMsg)
            }
            this.loading = false
          })
        } else {
          return false
        }
      })
    }
  },
  watch: {
    msgFather: function (curVal) {
      this.dialogFormVisible = curVal
    },
    dscatalogs(catalogs) {
      this.catalogCodes = []
      catalogs.forEach(catalog => {
        this.catalogCodes.push(catalog.code)
      })
    },
    regionGeom(val) {
      this.geometry = val
    },
    dialogFormVisible: function () {
      this.sendMsgToParent()
    },
    'item.deliveryType': {
      handler (newType, oldType) {
        if (newType === '1') {
          // 查询推送地址信息
          this.sapost('/dmc/ftp/ftpList', '', r => {
            this.addressList = r.data
            if (this.addressList.length === 0) {
              this.$message.warning('请添加推送地址信息！')
            }
          })
        }
        if (newType === '2') {
          // 查询邮寄地址信息
          this.sapost('/dmc/address/addressList', '', r => {
            this.addressList = r.data.addressList
            if (this.addressList.length === 0) {
              this.$message.warning('请添加邮寄地址信息！')
            }
          })
        }
        if (newType === '3') {
          // 查询接收地址信息
          this.sapost('/dmc/uploadServer/serverList', '', r => {
            this.addressList = r.data
            if (this.addressList.length === 0) {
              this.$message.warning('请添加接收地址信息！')
            }
          })
        }
      }
    }
  }
}
</script>
<style>
.el-button--success {
  margin-left: 15px;
  color: #fff;
  background-color: #18bc9c;
  border-color: #18bc9c;
}
.cshi {
  padding: 7px 7px;
}
.upfile {
  margin-top: 20px;
}
.abody {
  width: 90%;
  margin-left: 25%;
  display: flex;
  flex-flow: column;
  text-align: start;
  line-height: 2;
  padding-bottom: 10px;
  margin-top: 15px;
}
.dialog__header span {
  color: white;
}
.el-dialog {
    position: relative;
    margin: 0 auto 50px;
    border-radius: 8px;
    -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.deDialog {
  position: relative;
  margin: 0 auto 50px;
  border-radius: 8px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/HeadMenu/HeadDeliverySetDialog.vue